import { Autocomplete, Button, createFilterOptions, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Paper, Select, styled, Switch, SwitchProps, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import ic_dots from 'icons/ic_dots.svg';
import {ProjectConfig} from 'Global';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import EventIcon from '@mui/icons-material/Event';
import AutocompleteMulti from "elements/AutocompleteMulti";
import { useSnackbar, withSnackbar } from "notistack";


const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


 //TODAY DATE FORMATED MM/DD/YYYY
 const today = new Date('2014-08-18T21:11:54')




export default withSnackbar(
  function UserEditor(props: any) {

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  /*=======================================
    GET PROJECT ID AND ESTIMATE ID FROM URL
  =======================================*/
  let {user_id } = useParams();
  /*=======================================
  =======================================*/


  const navigate = useNavigate();
  const location = useLocation();
  const navigationUser = (location.state as any)?.user;

  const buildFormValues = (userData?: any) => ({
    user_id: String(userData?.user_id ?? user_id ?? "null"),
    name: String(userData?.name ?? ""),
    last_name: String(userData?.last_name ?? ""),
    phone: String(userData?.phone ?? ""),
    email: String(userData?.email ?? ""),
    password: String(userData?.password ?? ""),
    is_active:
      userData?.is_active === true ||
      userData?.is_active === 1 ||
      userData?.is_active === "1",
  });

  const defaultValues: any = buildFormValues();
  
  const [loading, setLoading] = useState(false); 
  const [formValues, setFormValues] = useState(() =>
    navigationUser && String(navigationUser.user_id) === String(user_id)
      ? buildFormValues(navigationUser)
      : defaultValues
  )
  const [roles_list, setRolesList] = useState<any []>([]);







  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };



  const handleSubmit = () => {


    console.log("formValues", formValues)
    
    axios.post(ProjectConfig.api_url, null,
      {
        params: {
          request: 'add_edit_user',
          formdata: JSON.stringify(formValues),
        }
      })
        .then((response) => {
          console.log(response); 
          if (response.data?.status === 'success') {
            enqueueSnackbar(
              response.data.message || "Usuario guardado correctamente",
              { variant: 'success' }
            );
            setLoading(true);
            navigate("/admin/usuarios");
          } else {
            enqueueSnackbar(
              response.data?.message || "Error al guardar el usuario",
              { variant: 'error' }
            );
          }
          
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        
  };



  /**/

  useEffect(() => {
    if (!user_id) {
      setFormValues(buildFormValues());
      return;
    }

    const hasNavigationUser =
      navigationUser &&
      String(navigationUser.user_id) === String(user_id);

    if (hasNavigationUser) {
      setFormValues(buildFormValues(navigationUser));
    }

    axios
      .get(ProjectConfig.api_url, {
        params: {
          request: "user_details",
          user_id: user_id,
        },
        responseType: "text",
        transformResponse: [(data) => data],
      })
      .then((response) => {
        let userData: any = response.data;

        /*
         * La API histórica puede responder JSON normal, JSON serializado
         * dentro de un string o texto con ruido alrededor. Normalizamos
         * cualquiera de esos casos antes de llenar el formulario.
         */
        for (let attempt = 0; attempt < 2 && typeof userData === "string"; attempt++) {
          const rawData = userData.trim();

          try {
            userData = JSON.parse(rawData);
            continue;
          } catch (_) {
            const jsonStart = rawData.indexOf("{");
            const jsonEnd = rawData.lastIndexOf("}");

            if (jsonStart === -1 || jsonEnd === -1 || jsonEnd < jsonStart) {
              throw new Error("La respuesta no contiene un objeto JSON válido.");
            }

            userData = JSON.parse(rawData.slice(jsonStart, jsonEnd + 1));
          }
        }

        if (userData?.data && typeof userData.data === "object") {
          userData = userData.data;
        }

        if (!userData || String(userData.user_id ?? "") !== String(user_id)) {
          throw new Error("La API no devolvió el usuario solicitado.");
        }

        setFormValues(buildFormValues(userData));
      })
      .catch((err) => {
        console.error("Error cargando usuario:", err);

        // Si venimos desde la lista, conservamos los datos precargados
        // y no dejamos el formulario vacío aunque falle el endpoint de detalle.
        if (!hasNavigationUser) {
          enqueueSnackbar(
            "No fue posible cargar los datos del usuario.",
            { variant: "error" }
          );
        }
      });
  }, [user_id]);


  return (
      <div id="userForm">
        <div className="userForm_right">
          <Box id="user_editor" className="box_editor" title="Usuario" subtitle="Editar"  >
            <div className='input_group'>
                <h2>Información Personal</h2>
                <div className='input_group'>
                    <div className='input_row'>
                    <TextField 
                      id="name"
                      name="name"
                      label="Nombres"
                      type="text"
                      required
                      fullWidth
                      value={formValues.name}
                      onChange={handleInputChange}
                    />

                    <TextField
                      id="last_name"
                      name="last_name"
                      label="Apellidos"
                      type="text"
                      required
                      fullWidth
                      value={formValues.last_name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <TextField
                    id="phone"
                    name="phone"
                    label="Teléfono"
                    type="text"
                    required
                    fullWidth
                    value={formValues.phone}
                    onChange={handleInputChange}
                  />

                </div>

                <div className='input_group'>
                  <h2>Información de sesión</h2>
                  <div className="input_row">
                    <TextField
                      id="email"
                      name="email"
                      label="Email"
                      type="text"
                      required
                      fullWidth
                      value={formValues.email}
                      onChange={handleInputChange}
                    />

                    <TextField
                      id="password"
                      name="password"
                      label="Password"
                      type="password"
                      required
                      fullWidth
                      value={formValues.password}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>


              <FormControlLabel
                control={
                  <IOSSwitch 
                    sx={{ m: 1 }}
                    checked={Boolean(formValues.is_active)}
                    onChange={(e) => {
                      setFormValues({
                        ...formValues,
                        ["is_active"]: e.target.checked
                      });
                    }
                    }
                  />
                }
                label="Activo"
              />



              

            </div>
            <div className='buttons'>
              <Button onClick={() => navigate("/admin/usuarios")} variant="outlined" className="button_2">Cancelar</Button>
              <Button onClick={handleSubmit} variant="contained" className="button_1">Guardar</Button>
            </div>
          </Box>
        </div>

        
          


      </div>
    
  );
  })
